import { MAP_UPDATE_GEOLOCATION } from '../Actions/GoogleMap.action';

let initialState = {
  selectedResellerItem: null,
  isDetailedView: false, 
};

export const googleMap = (state = initialState, action) => {
  switch (action.type) {
    case MAP_UPDATE_GEOLOCATION:
      const coordinatesDetails = action.payload.coordinates.split(',');
      return {
        ...state,
        selectedResellerItem: {
          address: action.payload.address,
          agentName: action.payload.agentName,
          coordinates: action.payload.coordinates,
          email: action.payload.email,
          phone: action.payload.phone,
          latitude: parseFloat(coordinatesDetails[0]),
          longitude: parseFloat(coordinatesDetails[1]),
          resellerWebsiteUrl: action.payload.resellerWebsiteUrl,
        },
        isDetailedView: true,
      };
    default:
      return state;
  }
};
